import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

/* MODELS

*/

export default class AuthorizationKeyService {



    /**
     * Get all videos for the client. with pagination
     * 
     * @param {string} token 
     * @return {[Video]}
     */
    getMyAuthorizationKeys(token, params) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/authorizationkeys/my',
                method: 'get',
                params: params,
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get all videos for the client. with pagination
     * 
     * @param {string} token 
     * @return {[Video]}
     */
    getAuthorizationKeys(token, params) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/authorizationkeys',
                method: 'get',
                params: params,
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getAuthorizationKeysOfFilteredVideos = (token, filter) => {
        return new Promise((done, reject) => {
            var authTable = [];
            var obj = {};

            var getAuth = (page) => {
                var req = {
                    method: 'get',
                    headers: {
                        'Authorization': 'Basic ' + token
                    },
                    url: base + '/api/videos',
                    params: {
                        page: page,
                        pagesize: 500,
                    }
                }
                if (filter !== undefined) {
                    req.params.filter = filter;
                }
                axios(req).then((response) => {
                    if (response.data._embedded.length > 0) {
                        for (let video of response.data._embedded) {
                            if (!obj.hasOwnProperty(video.authorizationKey)) {
                                authTable.push(video.authorizationKey);
                                obj[video.authorizationKey] = "Ok";
                            }
                        }
                        getAuth(page + 1);
                    } else {
                        done(authTable);
                    }
                }).catch((error) => {
                    reject(error);
                })
            }
            getAuth(1);
        })
    }

}